import { initialize } from "./initialize";
import { toastTypes } from "./toastTypes";

const toasts = {
  toastTypes,
};

initialize();

export { toasts };
